export default "__VITE_ASSET__CdFmkb5b__"